export const MODAL_TYPE_CATEGORIES_MANAGER_CONFIRM_DISCARD = 'categories-manager-confirm-discard';
